import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { Address } from 'src/app/models/address.model';
import { Appointment } from 'src/app/models/appointment.model';
import { ModalService } from 'src/app/services/modal.service';
import { SharedUIModuleModule } from 'src/app/shared/shared-uimodule/shared-uimodule.module';

@Component({
  selector: 'ubc-address-select-create',
  standalone: true,
  imports: [
    CommonModule,
    SharedUIModuleModule
  ],
  templateUrl: './address-select-create.component.html',
  styleUrl: './address-select-create.component.scss'
})
export class AddressSelectCreateComponent {
  modalEventSubscription?: Subscription
  @Input() appointment: Appointment
  @Output() addressSelected: EventEmitter<Address | undefined> = new EventEmitter()

  constructor(
    private modalService: ModalService,
    private apiService: APIServiceService
  ){}

  ngOnInit(){
    this.modalService.customer = this.appointment.customer

    this.modalEventSubscription = this.modalService.event$.subscribe((event) => {
      // Act upon the event here
      this.handleModalEvent(event);
    });
  }

  addressClicked(address: Address) {
    if(this.appointment.address && this.appointment.address.id === address.id){
      this.appointment.address = null
    } else {
      this.appointment.address = address
    }

    this.addressSelected.emit(this.appointment.address)

  }

  addressEditClicked(event: MouseEvent, address: Address){
    // console.log("Editing address ", address)
    this.modalService.openEditAddressModal(address)
  }

  newAddressClicked(){
    this.modalService.openNewAddressModal(this.appointment)
  }

  private async handleModalEvent(event: any): Promise<void> {
    if (event.type === 'CUSTOMER' && event.action === 'addresses_updated') {
      // Perform the desired action for this event
      console.log('HoAddressesrses updated for customer:', event);
      // Add your logic here

      const updatedAddresses = await this.apiService.customer.getAddresses(this.appointment.customer.id)

      this.appointment.customer.addresses = updatedAddresses.data.results
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.modalEventSubscription) {
      this.modalEventSubscription.unsubscribe();
    }
  }
}
